import { getBlockProps } from "../blocks-parser";

const props = {
  content: {
    source: "query",
    selector: "li",
    query: {
      item: {
        type: "string",
        source: "html",
      },
    },
  },
};

function getListContentSchema({ phrasingContentSchema }) {
  const listContentSchema = {
    ...phrasingContentSchema,
    ul: {},
    ol: { attributes: ["type", "start", "reversed"] },
  };

  // Recursion is needed.
  // Possible: ul > li > ul.
  // Impossible: ul > ul.
  ["ul", "ol"].forEach((tag) => {
    listContentSchema[tag].children = {
      li: {
        children: listContentSchema,
      },
    };
  });

  return listContentSchema;
}

const listSchema = {
  selector: "ol,ul",
  blockSlug: "grigora/list",
  schema: (args) => ({
    ol: getListContentSchema(args).ol,
    ul: getListContentSchema(args).ul,
  }),
  props,
  transform: (node) => {
    const blockProps = getBlockProps("grigora/list", node.outerHTML, props);

    return {
      blockSlug: "grigora/list",
      blockProps: {
        ...blockProps,
        content: blockProps?.content.map((i) => i.item),
      },
    };
  },
};

export { listSchema };
